import PosthogService from '~/services/posthog/PosthogService';

export function fireTodayShiftViewShiftClicked(): void {
  PosthogService.getInstance().track('dental_portal:today_shift:view_shift_clicked');
}
